<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form @submit.prevent="submit()">
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">Modificar Nombre</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        solo
                        v-model="klipy.deviceName"
                        label="Titulo"
                        required
                      />
                      <p v-show="mensajeError" style="color: red">
                        El nombre debe contener al menos un caracter
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn :disabled="working.wUpdate" flat @click="cancel">
              {{ $t('generic.cancel') }}
            </v-btn>
            <v-btn
              :disabled="working.wUpdate"
              color="primary darken-1"
              flat
              @click="editKlipy()"
            >
              {{ $t('generic.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..." />
    <success v-model="toast.success" text="Creación Exitosa" />
    <error v-model="toast.failed" :text="toast.eMessage" />
  </div>
</template>

<script>
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'

export default {
  props: ['klipy', 'value'],
  components: {
    loading,
    success,
    error,
  },
  mounted() {},
  data: () => ({
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: '',
    },
    data: [],
    mensajeError: false,
  }),
  methods: {
    cancel() {
      this.$emit('cancelled')
    },
    editKlipy() {
      this.data.deviceName = this.klipy.deviceName
      this.data.id = this.klipy.id
      this.working.loadingList = true
      if (this.klipy.deviceName != '') {
        this.$store
          .dispatch('ud/editNameK', this.data)
          .then((response) => {
            this.working.loadingList = false
            this.$emit('success')
            this.cancel()
          })
          .catch((error) => {
            this.working.loadingList = false
            console.log(error)
          })
      } else {
        this.mensajeError = true
      }
    },
  },
  computed: {
    titleErrors() {
      if (this.klipy.deviceName.$dirty && !this.klipy.deviceName.$model) {
        return ['El nombre debe contener al menos un caracter']
      }
      return []
    },
  },
}
</script>

<style></style>
